import { type ComponentProps, forwardRef, type HTMLAttributes } from 'react';
import cn from 'classnames';

import { MotionPicture } from '@/components/ui/Picture/Picture';

interface ClaimItemAnimationProps extends HTMLAttributes<HTMLDivElement> {
  quantityOfItems: number;
  itemProps: ComponentProps<typeof MotionPicture>;
  completeCallback?: (index: number) => void;
}

const ClaimItemAnimation = forwardRef<HTMLDivElement, ClaimItemAnimationProps>(
  ({ itemProps, quantityOfItems, completeCallback, ...props }, ref) => {
    return (
      <div ref={ref} {...props}>
        <div className="w-full h-full relative">
          {Array.from({ length: quantityOfItems }).map((_, index) => (
            <MotionPicture
              key={index}
              {...itemProps}
              custom={index}
              onAnimationComplete={(definition) => {
                itemProps.onAnimationComplete?.(definition);
                completeCallback?.(index);
              }}
              className={cn(
                'w-full h-full absolute top-0 left-0',
                itemProps.className,
              )}
            />
          ))}
        </div>
      </div>
    );
  },
);

export { ClaimItemAnimation };
